import { useRef } from 'react';
import type React from 'react';
import type { NormalButtonProps } from './normalButton';

const useNormalButton = ({
  onClick = () => {},
  isDebounceClick = true,
}: Pick<NormalButtonProps, 'onClick' | 'isDebounceClick'>) => {
  const debounceClickBottomButton = useRef(0);

  /**
   * Forwards a button press to the owning component while suppressing accidental double taps. Compares the current timestamp against the last recorded click held in a ref and bails out when debouncing is enabled and less than 300ms has elapsed, otherwise records the new timestamp and calls the supplied onClick handler with the event.
   *
   * @param e - Mouse event raised by the button press.
   * @returns Nothing.
   */
  const handleClick = (e: React.MouseEvent) => {
    if (isDebounceClick && new Date().getTime() - debounceClickBottomButton.current < 300) {
      return;
    }
    debounceClickBottomButton.current = new Date().getTime();
    onClick(e);
  };

  return { handleClick };
};

export default useNormalButton;
